/**
 * Shared Card Chips Component
 *
 * Renders a compact row of chips (e.g. amenities). Shows at most `max` chips
 * followed by a "+N" chip for the remaining ones.
 */

import { h } from 'preact';
import htm from 'htm';

const html = htm.bind(h);

/**
 * Card chips row.
 *
 * @param {Object} props
 * @param {string[]} props.items - Chip texts.
 * @param {number} [props.max=4] - Maximum number of chips shown.
 */
export function CardChips({ items, max = 4 }) {
  if (!items?.length) return null;

  const shown = items.slice(0, max);
  const hiddenCount = items.length - shown.length;

  return html`
    <div class="mta-card-chips" title=${hiddenCount > 0 ? items.join(', ') : undefined}>
      ${shown.map((text) => html`<span class="mta-card-chip">${text}</span>`)}
      ${hiddenCount > 0 ? html`<span class="mta-card-chip">+${hiddenCount}</span>` : ''}
    </div>
  `;
}
